import {useMemo} from '@wordpress/element';
import {applyFilters} from '@wordpress/hooks';
import {getStripeAmount} from '@wc-stripe/blocks-utils';

export const useElementOptions = (
    {
        gatewayId,
        cartTotal,
        currency,
        elementOptions,
        expressCheckout = false,
        shouldSavePayment = false,
    }) => {
    const amount = getStripeAmount(cartTotal.value, currency);
    return useMemo(() => {
        let options = {
            mode: 'payment',
            currency: currency?.code?.toLowerCase(),
            ...elementOptions
        };
        if (shouldSavePayment && options.mode !== 'subscription') {
            options.mode = 'setup';
        }
        if (amount <= 0 && options.mode !== 'subscription') {
            options = {...options, mode: 'setup'};
        }
        if (['payment', 'subscription'].includes(options.mode)) {
            options.amount = amount;
        }
        if (expressCheckout) {
            delete options.paymentMethodTypes;
        }
        return applyFilters('wc_stripe_blocks_element_options', options, gatewayId);
    }, [
        gatewayId,
        amount,
        currency?.code,
        expressCheckout,
        shouldSavePayment
    ]);
};
